import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { CrashReportApi } from "../../../../../../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	crashReport: CrashReportApi;
}

const CrashReportBasicInfoCard = ({ crashReport }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<Card>
			<Card.Header>{t("common.word.basic_data", { ns: "lib" })}</Card.Header>
			<Card.Body>
				<dl className="mb-0">
					<dt>{t("modules.crash_report.field.app_name.title")}</dt>
					<dd>{crashReport.app_name}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("common.word.app_version")}</dt>
					<dd>{crashReport.app_version}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("modules.crash_report.field.message.title")}</dt>
					<dd>{crashReport.short_message}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("modules.crash_report.field.count.title")}</dt>
					<dd>{crashReport.count}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("modules.crash_report.field.last_occurrence.title")}</dt>
					<dd>{FormatDate(crashReport.last_occurrence)}</dd>
				</dl>

				<dl className="mb-0">
					<dt>{t("lib:common.word.status")}</dt>
					<dd>{t(`enums.crash_reports.status.${crashReport.status}`)}</dd>
				</dl>

				<dl className="mb-0">
					<dt>{t("lib:common.word.type")}</dt>
					<dd>{t(`enums.crash_reports.type.${crashReport.type}`)}</dd>
				</dl>
			</Card.Body>
		</Card>
	);
};

export default CrashReportBasicInfoCard;
